export enum TableColumnSortEnum {
  ASC = 'asc',
  DESC = 'desc',
  NONE = '',
}
